import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';
import Reveal from './Reveal';
import Button from './Button';
import { useBookingModal } from '../booking/BookingModalContext';

interface CTASectionProps {
  title: ReactNode;
  description?: ReactNode;
  ctaLabel?: string;
  /** When omitted, the CTA opens the booking modal. */
  ctaHref?: string;
  tone?: 'dark' | 'sand' | 'paper';
  size?: 'md' | 'lg';
}

export default function CTASection({
  title,
  description,
  ctaLabel = 'Book Now',
  ctaHref,
  tone = 'sand',
  size = 'md',
}: CTASectionProps) {
  const { openBooking } = useBookingModal();
  const toneClasses = tone === 'dark' ? 'bg-ink' : tone === 'sand' ? 'bg-sand' : 'bg-paper';
  const titleColor = tone === 'dark' ? 'text-paper' : 'text-ink';
  const descColor = tone === 'dark' ? 'text-dark-muted' : 'text-muted';
  const padding = size === 'lg' ? 'py-20' : 'py-16';

  return (
    <section className={cn(toneClasses, padding, 'px-8 text-center')}>
      <Reveal>
        <h2 className={cn('font-serif font-medium text-[28px] md:text-[32px] m-0 mb-4', titleColor)}>{title}</h2>
        {description && <p className={cn('text-base m-0 mb-7', descColor)}>{description}</p>}
        {ctaHref ? (
          <Button href={ctaHref} size="lg">
            {ctaLabel}
          </Button>
        ) : (
          <Button onClick={() => openBooking()} size="lg">
            {ctaLabel}
          </Button>
        )}
      </Reveal>
    </section>
  );
}
